import React from 'react';
import PropTypes from "prop-types";

import {RS} from "../../../data/strings/global";
import * as SC from "../../../data/strings/RCStringConst";

import * as gbc from "../../GB/GBConst";

import RADAR_LogoFull from "../../../img/RADAR Logo.png";

import Menu from "@material-ui/core/Menu/Menu";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import IconButton from "@material-ui/core/IconButton/IconButton";
import DotsMenu from "@material-ui/icons/MoreVert";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";

import * as Theme from "../../../app/Theme";

import * as rcc from "../NonVisual/RCConst";
import * as rcu from "../NonVisual/RCUtil";

import TButton from '../../common/TButton';
import TDialog from "../../common/TDialog";
import TComboBox from "../../common/TComboBox";

const aboutMenuItem     = 1;
const settingsMenuItem  = 2;
const contactUsMenuItem = 3;

const aboutBtnHideWidth     = 810;
const settingsBtnHideWidth  = 920;
const contactUsBtnHideWidth = 1000;
const rightmostBtnHideWidth = contactUsBtnHideWidth;

class RCAppBarCustom extends React.Component {

    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {

        onAddTasks                      : PropTypes.func,

        country1DObjArray               : PropTypes.arrayOf(PropTypes.object),

        getDataVisChart                 : PropTypes.func,

        onDrawerChange                  : PropTypes.func,

        language                        : PropTypes.number,
        onLanguageChange                : PropTypes.func,

        pageID                          : PropTypes.string,
        onPageChange                    : PropTypes.func,

    };

    static defaultProps = {

        onAddTasks                      : () => console.log('onAddTasks'),

        country1DObjArray               : [],

        getDataVisChart                 : () => console.log("getDataVisChart"),

        onDrawerChange                  : () => console.log('onDrawerChange'),

        language                        : gbc.language.english,
        onLanguageChange                : () => console.log("onLanguageChange"),

        pageID                          : "",
        onPageChange                    : () => console.log('onPageChange'),

    };

    state = {

        fileAnchor              : null,
        showAboutDialogBool     : false,
        showContactUsDialogBool : false,
        showSettingsDialogBool  : false,
        windowInnerWidth        : 0,

    };

    componentDidMount() {

        this.onResize();
        window.addEventListener("resize", this.onResize);

    }

    componentWillUnmount() {

        window.removeEventListener("resize", this.onResize);

    }

    /* By making the inner width state and setting it when the screen resizes, we can update the app bar controls
       based on the width of the screen. */
    onResize = () => {

        this.setState({

            fileAnchor       : null,
            windowInnerWidth : window.innerWidth,

        });

    };

    handleFileBtnClick = (event) => {

        this.setState({

            fileAnchor : event.currentTarget,

        });

    };

    handleFileBtnClose = () => {

        this.setState ({

            fileAnchor: null,

        });

    };

    onDotMenuItemClick = (menuItemByte) => {

        try {

            this.setState({

                fileAnchor : null,

            }, () => {

                switch (menuItemByte) {

                    case aboutMenuItem :
                        this.onAboutBtnClick();
                        break;

                    case settingsMenuItem :
                        this.onSettingsBtnClick();
                        break;

                    case contactUsMenuItem :
                        this.onContactUsBtnClick();
                        break;

                    default :
                        break;

                }

            });

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    getButtonStyle = (buttonEnabledBool, pageIDStr) => {

        try {

            let style;

            if (buttonEnabledBool) {
                if (this.props.pageID === pageIDStr) {
                    style = Theme.styles.buttonSelectedLab;
                }
                else {
                    style = Theme.styles.buttonLab;
                }
            }
            else {
                style = Theme.styles.buttonDisabledLab;
            }

            return style;

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);
            return {};

        }

    };

    onAboutBtnClick = () => {

        this.setState({

            showAboutDialogBool : !this.state.showAboutDialogBool,

        });

    };

    onSettingsBtnClick = () => {

        this.setState({

            showSettingsDialogBool : !this.state.showSettingsDialogBool,

        });

    };

    onContactUsBtnClick = () => {

        this.setState({

            showContactUsDialogBool : !this.state.showContactUsDialogBool,

        });

    };

    onLanguageComboBoxChange = (value, text, info) => {

        try {

            /* Local storage is synchronous, so the main thread will wait until setItem executes. Set the language into
               local storage FIRST. Changing the language in appState forces the app to redraw. It will use whatever
               language is set into local storage via our global string function, RS in global.js. Local storage is used so
               language persists if the user reloads the app. The language field in app state is used to set up the
               language combo box appropriately.*/
            localStorage.setItem("userLanguage", info);

            this.props.onLanguageChange(info);

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    onPageChange = (id) => {

        try {

            this.props.onPageChange(id);

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    renderAboutDialog = () => {

        try {

            let dialog = null;

            /* State */
            const state = this.state;
            const showAboutDialogBool = state.showAboutDialogBool;

            if (showAboutDialogBool) {

                const rsscImg =
                    <div
                        style = {{
                            alignItems : "center",
                            display    : "flex",
                        }}
                    >
                        <img
                            alt     = {""}
                            style   = {{
                                height       : 60,
                            }}
                            src   = {RADAR_LogoFull}
                        />

                        <p
                            style = {{
                                color        : Theme.RC_PalatinatePurple,
                                fontSize     : 40,
                                lineHeight   : 1.1,
                                marginBottom : 0,
                                marginLeft   : Theme.leftIndent,
                                marginTop    : 7,
                            }}
                        >
                            {RS(SC.GB_stSampleSizeCalculator)}
                        </p>
                    </div>;

                const rsscImgDivider =
                    <Divider
                        style = {{
                            color     : Theme.gray,
                            marginTop : 20,
                        }}
                    />;

                const aboutRSSC_Lab =
                    <p
                        style   = {{
                            ...Theme.labelStyle,
                            color      : Theme.blackColor,
                            display    : "block",
                            fontSize   : 24,
                        }}
                    >
                        {RS(SC.GB_stAboutRSSC)}
                    </p>;

                const aboutRSSC_Text =
                    <p>
                        {RS(SC.GB_stAboutRADARText)}&nbsp;

                        <Link
                            onClick   = {() => rcu.URL_Click(rcc.RADARProjectURL)}
                            style     = {{
                                color   : Theme.RC_PrimaryColor,
                                cursor  : "pointer",
                            }}
                            underline = {"hover"}
                        >
                            {rcc.RADARProjectURL}
                        </Link>
                        .
                    </p>;

                const aboutRSSC_Divider =
                    <Divider
                        style = {{
                            color : Theme.gray,
                        }}
                    />;

                const creditsLab =
                    <p
                        style   = {{
                            ...Theme.labelStyle,
                            color      : Theme.blackColor,
                            display    : "block",
                            fontSize   : 24,
                        }}
                    >
                        {RS(SC.GB_stCredits)}
                    </p>;

                const welcomePageText =
                    <h5
                        style = {{
                            marginBottom : 0,
                        }}
                    >
                        {RS(SC.GB_stWelcomePageImage)}:
                    </h5>;

                const creditText =
                    <h6
                        style = {{
                            marginTop : 0,
                        }}
                    >
                        ID 86310315 © Kts | Dreamstime.com
                    </h6>;

                let dialogContent = [];
                dialogContent.push(rsscImg);
                dialogContent.push(rsscImgDivider);
                dialogContent.push(aboutRSSC_Lab);
                dialogContent.push(aboutRSSC_Text);
                dialogContent.push(aboutRSSC_Divider);
                dialogContent.push(creditsLab);
                dialogContent.push(welcomePageText);
                dialogContent.push(creditText);

                dialog =
                    <TDialog
                        actions         = {["mrClose"]}
                        closeBtnCaption = {RS(SC.GB_stCloseBtn)}
                        onClose         = {this.onAboutBtnClick}
                        content         = {dialogContent}
                        key             = {"aboutDialog"}
                        maxWidth        = {"md"}
                        style           = {{
                            width : 700,
                        }}
                    />;

            }

            return dialog;

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);
            return null;

        }

    };

    renderSettingsDialog = () => {

        try {

            let dialog = null;

            /* props */
            const props = this.props;
            const language = props.language;

            /* state */
            const state = this.state;
            const showSettingsDialogBool = state.showSettingsDialogBool;

            if (showSettingsDialogBool) {

                const languageComboBox =
                    <TComboBox
                        caption      = {RS(SC.GB_stLanguage)}
                        captionStyle = {{
                            fontSize : 16,
                        }}
                        onChange     = {this.onLanguageComboBoxChange}
                        info         = {[
                            gbc.language.english,
                            gbc.language.french,
                        ]}
                        itemIndex    = {language - 1}
                        items        = {[
                            RS(SC.GB_stEnglish),
                            RS(SC.GB_stFrench),
                        ]}
                        key          = {"languageComboBox"}
                    />;

                let dialogContent = [];
                dialogContent.push(languageComboBox);

                dialog =
                    <TDialog
                        actions         = {["mrClose"]}
                        closeBtnCaption = {RS(SC.GB_stCloseBtn)}
                        onClose         = {this.onSettingsBtnClick}
                        content         = {dialogContent}
                    />;

            }

            return dialog;

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);
            return null;

        }

    };

    renderContactUsDialog = () => {

        try {

            let dialog = null;

            /* state */
            const state = this.state;
            const showContactUsDialogBool = state.showContactUsDialogBool;

            if (showContactUsDialogBool) {

                const contactUsLab =
                    <p
                        style   = {{
                            ...Theme.labelStyle,
                            color        : Theme.blackColor,
                            display      : "block",
                            fontSize     : 24,
                            marginBottom : 20,
                            marginTop    : 0,
                        }}
                    >
                        {RS(SC.GB_stContactUs)}
                    </p>;

                const divider =
                    <Divider
                        style = {{
                            color : Theme.gray,
                        }}
                    />;

                const contactUsLink =
                    <p>
                        {RS(SC.GB_stQuestComments)}:

                        <br></br>

                        <Link
                            href    = {"mailto:" + rcc.contactEmailAddress}
                            style   = {{
                                color   : Theme.RC_PrimaryColor,
                                cursor  : "pointer",
                            }}
                            underline = {"hover"}
                        >
                            {rcc.contactEmailAddress}
                        </Link>
                    </p>;

                let dialogContent = [];
                dialogContent.push(contactUsLab);
                dialogContent.push(divider);
                dialogContent.push(contactUsLink);

                dialog =
                    <TDialog
                        actions         = {["mrClose"]}
                        closeBtnCaption = {RS(SC.GB_stCloseBtn)}
                        onClose         = {this.onContactUsBtnClick}
                        content         = {dialogContent}
                    />;

            }

            return dialog;

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);
            return null;

        }

    };

    render() {

        try {
            /* State */
            const state = this.state;
            const fileAnchor = state.fileAnchor;
            const windowInnerWidth = state.windowInnerWidth;

            let aboutBtn = null;
            let aboutMenuItemComp = null;
            let settingsBtn = null;
            let settingsMenuItemComp = null;
            let contactUsBtn = null;
            let contactUsMenuItemComp = null;
            let dotsMenuDiv = null;

            if (windowInnerWidth > aboutBtnHideWidth) {

                aboutBtn =
                    <TButton
                        caption        = {RS(SC.GB_stAbout)}
                        captionStyles  = {{
                            color          : Theme.blackColor,
                            fontFamily     : Theme.fontFamily,
                            fontSize       : 16,
                            textDecoration : "underline",
                        }}
                        key            = {"aboutBtn"}
                        transparent    = {true}
                        containerStyle = {{
                            display : "inline-block",
                        }}
                        onClick        = {this.onAboutBtnClick}
                    />;

            }
            else {

                aboutMenuItemComp =
                    <MenuItem
                        onClick = {() => this.onDotMenuItemClick(aboutMenuItem)}
                    >
                        {RS(SC.GB_stAbout)}
                    </MenuItem>;

            }

            if (windowInnerWidth > settingsBtnHideWidth) {

                settingsBtn =
                    <TButton
                        caption        = {RS(SC.GB_stLanguage)}
                        captionStyles  = {{
                            color          : Theme.blackColor,
                            fontFamily     : Theme.fontFamily,
                            fontSize       : 16,
                            textDecoration : "underline",
                        }}
                        key            = {"settingsBtn"}
                        transparent    = {true}
                        containerStyle = {{
                            display : "inline-block",
                        }}
                        onClick        = {this.onSettingsBtnClick}
                    />;

            }
            else {

                settingsMenuItemComp =
                    <MenuItem
                        onClick = {() => this.onDotMenuItemClick(settingsMenuItem)}
                    >
                        {RS(SC.GB_stSettings)}
                    </MenuItem>;

            }

            if (windowInnerWidth > contactUsBtnHideWidth) {

                contactUsBtn =
                    <TButton
                        caption        = {RS(SC.GB_stContactUs)}
                        captionStyles  = {{
                            color          : Theme.blackColor,
                            fontFamily     : Theme.fontFamily,
                            fontSize       : 16,
                            textDecoration : "underline",
                        }}
                        key            = {"contactusBtn"}
                        transparent    = {true}
                        containerStyle = {{
                            display : "inline-block",
                        }}
                        onClick        = {this.onContactUsBtnClick}
                    />;

            }
            else {

                contactUsMenuItemComp =
                    <MenuItem
                        onClick = {() => this.onDotMenuItemClick(contactUsMenuItem)}
                    >
                        {RS(SC.GB_stContactUs)}
                    </MenuItem>;

            }

            if (windowInnerWidth <= rightmostBtnHideWidth) {

                const dotsMenuBtn =
                    <IconButton
                        aria-label    = "Menu"
                        aria-owns     = {fileAnchor ? 'file-menu' : null}
                        aria-haspopup = "true"
                        color         = {"secondary"}
                        onClick       = {this.handleFileBtnClick}
                    >
                        <DotsMenu/>
                    </IconButton>;

                const dotsMenu =
                    <Menu
                        id                 = "file-menu"
                        anchorEl           = {fileAnchor}
                        open               = {Boolean(fileAnchor)}
                        onClose            = {this.handleFileBtnClose}
                        getContentAnchorEl = {null}
                        anchorOrigin       = {{
                            vertical   : 'bottom',
                            horizontal : 'left',
                        }}
                    >
                        {aboutMenuItemComp}
                        {settingsMenuItemComp}
                        {contactUsMenuItemComp}
                    </Menu>;

                dotsMenuDiv =
                    <div
                        style = {{
                            display : 'inline-block',
                            float   : "right",
                        }}
                    >
                        {dotsMenuBtn}
                        {dotsMenu}
                    </div>;

            }

            const btnDiv =
                <div
                    key   = {"btnDiv"}
                    style = {{
                        alignItems     : "center",
                        display        : "flex",
                        flexDirection  : "row",
                        float          : "right",
                    }}
                >
                    {aboutBtn}
                    {settingsBtn}
                    {contactUsBtn}
                </div>;

            const aboutDialog = this.renderAboutDialog();
            const settingsDialog = this.renderSettingsDialog();
            const contactUsDialog = this.renderContactUsDialog();

            return (

                <div
                    key     = {"RCAppBarCustomDiv"}
                    style = {{
                        width : "100%",
                    }}
                >

                    {dotsMenuDiv}
                    {btnDiv}
                    {aboutDialog}
                    {settingsDialog}
                    {contactUsDialog}

                </div>

            );

        }
        catch (exception) {

            return (

                <React.Fragment>

                    <h3>
                        {exception.name + ': ' + exception.message}
                    </h3>

                </React.Fragment>

            );

        }

    }

}

export default RCAppBarCustom;

